<template>
    <div class="sp-navi">
        <ul>
            <li><span><a href="/company/aboutus" v-bind:title="$t('tlAboutUs')" :class="selectedid == 'tlAboutUs' ? 'active': ''">{{$t('tlAboutUs')}}</a></span></li> 
            <li><span><a href="/company/culture" v-bind:title="$t('tlCulture')" :class="selectedid == 'tlCulture' ? 'active': ''">{{$t('tlCulture')}}</a></span></li>
            <li><span><a href="/company/rnd" v-bind:title="$t('tlRND')" :class="selectedid == 'tlRND' ? 'active': ''">{{$t('tlRND')}}</a></span></li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['selectedid'],
    name: "SpNavi"
}
</script>



// WEBPACK FOOTER //
// src/components/company/spnavi.vue